// extracted by mini-css-extract-plugin
export default {"textAria":"TextArea_textAria__S8d-X"};